import React, { FC } from "react";
import { useFormatter } from "kw/util/useFormatter";

import { SummaryTable } from "./SummaryTable";

type TAdminPremiumBreakdownSection = {
  quote: TQuote;
};
export const AdminPremiumBreakdownSection: FC<TAdminPremiumBreakdownSection> = ({
  quote,
}) => {
  const { formatCurrency, formatPercent } = useFormatter();
  const basePremiumDetails = [
    {
      id: "pre-tax-premium",
      label: "Base Premium",
      value: formatCurrency(quote?.preTaxPremium),
    },

    {
      id: "commission",
      label: "Commission (incl. GST)",
      value: formatCurrency(quote?.commission),
    },
  ];

  const premiumDetailsFeesEtc = quote?.fees?.breakdown?.map((fee) => ({
    id: fee?.feeType?.key?.toLowerCase().split(" ").join("-"),
    label: fee?.feeType?.label,
    value: formatCurrency(fee?.amount),
  }));

  const formatterMap = {
    percentage: formatPercent,
    currency: formatCurrency,
  };
  const premiumDetailsPricingOthers = quote?.pricingOthers?.display?.map((fee) => {
    const formatter = formatterMap[fee?.type];
    return {
      id: fee?.label?.toLowerCase().split(" ").join("-"),
      label: fee?.label,
      value: formatter ? formatter(fee?.value) : fee?.value,
    };
  });

  const premiumDetails = basePremiumDetails
    .concat(premiumDetailsFeesEtc)
    .concat(premiumDetailsPricingOthers || []);

  premiumDetails.push({
    id: "post-tax-premium",
    label: "Gross Premium (incl. GST)",
    value: formatCurrency(quote?.postTaxPremium),
  });

  premiumDetails.push({
    id: "amount-due",
    label: "Net Premium", // QBE requested this to be changed to Net Premium
    value: formatCurrency(quote?.amountDue),
  });

  return <SummaryTable data={premiumDetails} chunks={2} type="PREMIUM" />;
};
